import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";

export const MSG_EXPIRED = "Abonelik süreniz dolduğu için bu işlemi gerçekleştiremezsiniz. İşlemlerinize devam etmek için aboneliğinizi yenileyin.";
export const MSG_SUSPENDED = "İşletmeniz yönetici tarafından askıya alınmıştır. Bu işlemi gerçekleştiremezsiniz.";
export const MSG_PENDING = "İşletmeniz henüz yönetici tarafından onaylanmadığı için bu işlemi gerçekleştiremezsiniz.";

let cache = { at: 0, p: null };
export const fetchSub = () => {
  if (!cache.p || Date.now() - cache.at > 30000) {
    cache = { at: Date.now(), p: api.get("/provider/subscription").then((r) => r.data).catch(() => null) };
  }
  return cache.p;
};

// locked: kayıt düzenleme kapalı (süresi dolmuş/askıda). tradeLocked: yeni ticari işlem kapalı (+ onay bekliyor).
export function useSubLock() {
  const [s, setS] = useState(null);
  useEffect(() => { let on = true; fetchSub().then((d) => { if (on) setS(d); }); return () => { on = false; }; }, []);
  const st = s?.status;
  const locked = st === "expired" || st === "suspended";
  const tradeLocked = !!s && !s.entitled;
  const msg = st === "suspended" ? MSG_SUSPENDED : st === "pending_approval" ? MSG_PENDING : MSG_EXPIRED;
  return { s, locked, tradeLocked, msg };
}

export const LockNotice = ({ msg, testid = "sub-lock-notice", renew = true }) => (
  <div className="rounded-xl border border-destructive/40 bg-destructive/10 p-3 text-sm flex flex-wrap items-start gap-2" data-testid={testid}>
    <Lock className="w-4 h-4 mt-0.5 text-destructive shrink-0" />
    <span className="flex-1 min-w-[200px]">{msg}</span>
    {renew && msg !== MSG_SUSPENDED && msg !== MSG_PENDING && (
      <Link to="/panel?tab=membership" className="font-semibold underline shrink-0" data-testid={`${testid}-renew`}>Aboneliği yenile</Link>
    )}
  </div>
);
